import { Caption } from '@vrzl/ui';

import { SourceButton } from '@/domains/overview/components/sourcedValue';
import { type AnswerSource, pagesLabel } from '@/domains/overview/utils/sources';

type SourceReferenceProps = {
  eventId: string;
  criterionId: string;
  source: AnswerSource;
  highlightQuery: string | undefined;
};

/**
 * Documentnaam met pagina's, gevolgd door de bestaande bronknop die het
 * document op het fragment opent. De knop print niet; de tekst wel.
 */
export function SourceReference({ eventId, criterionId, source, highlightQuery }: SourceReferenceProps) {
  const label = [source.docName, pagesLabel(source.pages)].filter(Boolean).join(' · ');
  return (
    <div className="flex flex-wrap items-center gap-1">
      <Caption tone="subtle">{label}</Caption>
      <span className="print:hidden">
        <SourceButton
          eventId={eventId}
          criterionId={criterionId}
          source={source}
          highlightQuery={highlightQuery}
        />
      </span>
    </div>
  );
}
